import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useCountdown} from "../../hooks/useCountdown";
import {newPageLog} from "../../utils/helpers";
import "./styles.css";
import styles from "./styles.module.css";
import PollTitleContainer from "./PollTitleContainer";
import IllustrationWrapper from "./IllustrationWrapper";

export default function GetReady({question, handleGetReadyComplete, pollTitle, websocketState}) {
    const {t} = useTranslation();
    const {questionStartTime} = question;
    const {getReturnValues, resetCountdown} = useCountdown(new Date(questionStartTime).getTime());
    const [days, hours, minutes, seconds, milliSeconds] = getReturnValues;

    useEffect(() => {
        newPageLog("GetReady.js");
    }, []);

    const renderCounter = () => {
        const secondsRemain = days * 60 * 60 * 24 + hours * 60 * 60 + minutes * 60 + seconds + milliSeconds / 1000;

        if (secondsRemain < 1) {
            return (
                <div className={`${styles.getReadyCountDownContainer} ${styles.small}`}>
                    <span style={{fontSize: 15, fontWeight: "700"}}>{t("poll.getReady")}</span>
                    <span>{t("poll.go")}</span>
                </div>
            );
        } else {
            let seconds = Math.floor(secondsRemain);
            seconds = seconds < 0 ? 0 : seconds;

            return (
                <div className={`${styles.getReadyCountDownContainer} ${seconds >= 10 ? styles.small : ""}`}>
                    <span className={styles.countDownBlink}>{seconds}</span>
                </div>
            );
        }

    }

    useEffect(() => {
        resetCountdown(questionStartTime);
    }, [questionStartTime]);

    useEffect(() => {
        if (days + hours + minutes + seconds + milliSeconds <= 0) {
            handleGetReadyComplete();
        }
    }, [seconds]);


    return (
        <div className={styles.generalContainer} style={{height: "unset", flex: 1}}>
            <PollTitleContainer pollTitle={pollTitle}/>
            <span style={{flex: 1}}/>
            <IllustrationWrapper>
                {renderCounter()}
            </IllustrationWrapper>

            <span className={styles.waitingRoomTitle}>
                {t('poll.getReadyPageTitle')}
            </span>
            <span className={styles.waitingRoomDesc}>
                {t('poll.getReadyPageExplain')}
            </span>
            <span style={{flex: 2}}/>
        </div>
    );
}
